'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../node_modules/@radix-ui/react-tooltip/dist/index.cjs');
var React = require('react');
var Typography_web = require('../Typography/Typography.web.cjs');
var RoundedArrow = require('./RoundedArrow.cjs');
var Tooltip_web_styles = require('./Tooltip.web.styles.cjs');

/**
 * The Tooltip component wraps around a trigger element and shows a tooltip when hovered or focused.
 *
 * {@link https://aviary.fullscript.io/latest/components/tooltip/web-41MnsKX9 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Tooltip/Tooltip.web.tsx | View in GitLab}
 *
 * @scope Web
 */ const Tooltip = ({ intention = "neutral", enterDelay = 100, isTooltipHidden, children, tooltipContent, isOpen, isTriggerWidth, alignment = "bottom", customCss, ...rest })=>{
    const currentTheme = react.useTheme();
    const contentStyles = [
        Tooltip_web_styles.tooltipContent,
        intention && Tooltip_web_styles.tooltipIntentions(currentTheme, intention),
        isTriggerWidth && Tooltip_web_styles.triggerWidthContent
    ];
    const arrowStyles = [
        intention && Tooltip_web_styles.arrowIntentions(currentTheme, intention)
    ];
    const getTabIndex = ()=>{
        const childrenHasButton = React.Children.toArray(children).some((child)=>{
            if (typeof child === "object" && "type" in child) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                return child.type?.displayName === "Button";
            }
            return false;
        });
        return childrenHasButton ? undefined : 0;
    };
    const renderArrow = ()=>/*#__PURE__*/ jsxRuntime.jsx(index.Arrow, {
            asChild: true,
            css: arrowStyles,
            width: 12,
            height: 8,
            children: /*#__PURE__*/ jsxRuntime.jsx(RoundedArrow.RoundedArrow, {})
        });
    const renderContent = ()=>/*#__PURE__*/ jsxRuntime.jsx(index.Portal, {
            children: /*#__PURE__*/ jsxRuntime.jsxs(index.Content, {
                css: contentStyles,
                className: "TooltipContent",
                sideOffset: 2,
                side: alignment,
                align: "center",
                collisionPadding: 16,
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                        variant: "caption",
                        children: tooltipContent
                    }),
                    renderArrow()
                ]
            })
        });
    if (isTooltipHidden) return React.Children.only(children);
    return /*#__PURE__*/ jsxRuntime.jsx(index.Provider, {
        delayDuration: enterDelay,
        children: /*#__PURE__*/ jsxRuntime.jsxs(index.Root, {
            open: isOpen,
            children: [
                /*#__PURE__*/ jsxRuntime.jsx(index.Trigger, {
                    asChild: true,
                    children: /*#__PURE__*/ jsxRuntime.jsx("div", {
                        role: "status",
                        tabIndex: getTabIndex(),
                        "data-testid": "aviary-tooltip-trigger",
                        css: [
                            Tooltip_web_styles.triggerWrapper,
                            customCss
                        ],
                        ...rest,
                        children: children
                    })
                }),
                renderContent()
            ]
        })
    });
};

exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.web.cjs.map
